import { GetTicketsByFiltersDtoProps } from "api/DTOs/GetTicketsByFiltersDto"
import { formatCurrency } from "common/utils/currency"
import { TFunction } from "i18next"
import { frontendDateFormat } from "utils/formatDate"
import { EstadoRevisionActual } from "../components/EstadoRevisionActual/EstadoRevisionActual"
import { ManipulatedField } from "../components/ManipulatedField"

export const TICKETS_COLUMNS = (
  t: TFunction,
  onRenderEstadoConciliacion: (
    cell: GetTicketsByFiltersDtoProps
  ) => JSX.Element | string
) => {
  const columns = [
    {
      header: t("tickets.table.emisionDateLabel"),
      field: "fechaEmision",
      key: "fechaEmision",
      body: ({
        fechaEmision,
        haSidoModificado,
        id,
      }: GetTicketsByFiltersDtoProps) =>
        ManipulatedField({
          t,
          isManipulated: Boolean(haSidoModificado),
          isFirstColumn: true,
          id,
          className: "tw-py-3 tw-pl-4 tw-pr-3",
          children: fechaEmision
            ? frontendDateFormat(new Date(fechaEmision))
            : "",
        }),
      style: { width: "10%" },
      sortable: true,
      sortField: "fechaEmision",
      className: "!tw-p-0 !tw-h-12",
    },
    {
      header: t("tickets.table.nameLabel"),
      field: "nombre",
      key: "nombre",
      style: { width: "15%" },
      sortable: true,
      sortField: "nombre",
      className: "!tw-p-0 !tw-h-12",
      body: ({ nombre, haSidoModificado }: GetTicketsByFiltersDtoProps) =>
        ManipulatedField({
          isManipulated: Boolean(haSidoModificado),
          children: nombre || "",
        }),
    },
    {
      header: t("tickets.table.numberLabel"),
      field: "numero",
      key: "numero",
      style: { width: "15%" },
      sortable: true,
      sortField: "numero",
      className: "!tw-p-0 !tw-h-12",
      body: ({ numero, haSidoModificado }: GetTicketsByFiltersDtoProps) =>
        ManipulatedField({
          isManipulated: Boolean(haSidoModificado),
          children: numero || "",
        }),
    },
    {
      header: t("tickets.table.contactLabel"),
      key: "contacto",
      field: "contacto",
      body: ({ contacto, haSidoModificado }: GetTicketsByFiltersDtoProps) =>
        ManipulatedField({
          isManipulated: Boolean(haSidoModificado),
          children: contacto || "",
        }),
      sortable: true,
      sortField: "Empresa.RazonSocial",
      className: "!tw-p-0 !tw-h-12",
    },
    {
      header: t("crear.pedido.tab.headerState"),
      field: "estadoRevisionActual",
      key: "estadoRevisionActual",
      body: ({
        estadoAprobacion,
        id,
        haSidoModificado,
      }: GetTicketsByFiltersDtoProps) =>
        ManipulatedField({
          isManipulated: Boolean(haSidoModificado),
          children: estadoAprobacion
            ? EstadoRevisionActual(estadoAprobacion, id)
            : "",
        }),
      style: { width: "11%" },
      sortable: true,
      alignCol: "center",
      sortField: "EstadoAprobacion",
      className: "!tw-p-0 !tw-h-12",
    },
    {
      header: t("tickets.table.headerReconcile"),
      field: "conciliacionBancaria",
      key: "conciliacionBancaria",
      body: ({
        conciliacionBancaria,
        haSidoModificado,
      }: GetTicketsByFiltersDtoProps) =>
        ManipulatedField({
          isManipulated: Boolean(haSidoModificado),
          children: onRenderEstadoConciliacion({ conciliacionBancaria }) || "",
        }),
      style: { width: "11%" },
      sortable: false,
      alignCol: "center",
      sortField: "conciliacionBancaria",
      className: "!tw-p-0 !tw-h-12",
    },
    {
      header: t("tickets.table.importLabel"),
      field: "importe",
      key: "importe",
      className: "!tw-p-0 !tw-h-12 !tw-text-end",
      style: { width: "11%" },
      body: ({ importe, haSidoModificado }: GetTicketsByFiltersDtoProps) =>
        ManipulatedField({
          isManipulated: Boolean(haSidoModificado),
          className: "tw-justify-end tw-pr-10",
          children: formatCurrency(importe) || "",
        }),
      sortable: true,
      alignCol: "right",
      sortField: "Conceptos.Sum(c=>c.Cantidad*c.Precio)",
    },
  ]
  return columns
}
